import React, { useEffect, useState } from "react";
import "./Popular.css";
import Item from "../Items/Item";

const Popular = () => {
  const [popularProducts, setPopularProducts] = useState([]);
  const API_BASE = process.env.REACT_APP_API_BASE_URL; // .env URL

  useEffect(() => {
    const fetchPopular = async () => {
      try {
        const response = await fetch(`${API_BASE}/api/products/popularinwomen`);
        if (!response.ok) {
          console.error("Error fetching popular products:", response.status);
          return;
        }
        const data = await response.json();
        setPopularProducts(data);
      } catch (err) {
        console.error("Server error fetching popular products:", err);
      }
    };
    fetchPopular();
  }, [API_BASE]);

  return (
    <div className="popular">
      <h1>Featured Collection</h1>
      <hr />
      <div className="popular-item">
        {popularProducts.length === 0 && <p>No popular products found.</p>}
        {popularProducts.map((item, i) => (
          <Item
            key={i}
            id={item.id}
            name={item.name}
            image={item.image}
            new_price={item.new_price}
            old_price={item.old_price}
          />
        ))}
      </div>
    </div>
  );
};

export default Popular;
